import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IncomeStatisticsResponse } from '../../types/statistics';

interface IncomeSummaryCardsProps {
  incomeData: IncomeStatisticsResponse;
}

const IncomeSummaryCards: React.FC<IncomeSummaryCardsProps> = ({ incomeData }) => {
  const { t } = useTranslation();

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN',
    }).format(amount);
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 3,
        mb: 4,
      }}
    >
      <Card>
        <CardContent>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {t('statistics.finalizedAppointments')}
          </Typography>
          <Typography variant="h4" sx={{ color: '#2e7d32' }}>
            {formatCurrency(incomeData.finalizedAppointments)}
          </Typography>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {t('statistics.soldProducts')}
          </Typography>
          <Typography variant="h4" color="secondary">
            {formatCurrency(incomeData.soldProducts)}
          </Typography>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {t('statistics.predictedIncome')}
          </Typography>
          <Typography variant="h4" sx={{ color: '#1976d2' }}>
            {formatCurrency(incomeData.predictedIncome)}
          </Typography>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {t('statistics.totalIncome')}
          </Typography>
          <Typography variant="h4" sx={{ color: '#6a1b9a' }}>
            {formatCurrency(incomeData.total)}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default IncomeSummaryCards;

